import moment from 'moment';

// SQL task timestamps use the same wall-clock convention as the task calendar.
const taskMoment = value => typeof value === 'string'
    ? moment(value.replace(/Z/g, ''), moment.ISO_8601, true)
    : moment(value);

const occurrenceDate = task => {
    for (const value of [task.start_time_actual, task.tas_start_time, task.tas_start_date]) {
        if (!value) continue;
        const date = taskMoment(value);
        if (date.isValid()) return date;
    }
    return null;
};

export const buildTaskActivityItems = (tasks, now = moment()) => {
    const seen = new Set();
    return (tasks || []).filter(task => {
        if (!task || Number(task.tas_is_active) === 2) return false;
        const date = occurrenceDate(task);
        if (!date || !date.isSameOrBefore(now)) return false;
        const key = task.tas_id || `${task.tas_title || ''}-${date.toISOString()}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    }).map(task => ({
        type: 'task',
        // Recurring occurrences are created together; creation time is not visit time.
        date: occurrenceDate(task).toISOString(),
        title: task.tas_title || task.tas_type || 'Task',
        subTitle: task.tas_type || '',
        content: task.tas_description || '',
        createdBy: task.emp_first_name ? `${task.emp_first_name} ${task.emp_last_name}` : null,
        empType: null,
        audioSrc: null,
        editNote: null,
    }));
};